import React, {Fragment, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

// controls
import Table, {Column} from '../../table'
//helpers
import {
    formatDatetime,
    getCategoryFilterType,
    getNameVehicle,
    useHandleExportReport
} from 'Modules/reports/views/main/components/reportsTab/helper';

//hooks
import {useSidePanelMap, useTableReport} from 'Core/hooks';
//actions
import {clearRedux, reportsMainGenerateEvents, reportsMainGenerateReportUpdate} from 'Redux/actions'
import moment from 'moment';

const DiagnosticIndicatorsReport = (props) => {
    const {messages, report} = props;
    const {data, filters, summary, loadingSummary, timeZone} = report;
    const {filterEntity, otherFilters, startRange, endRange} = filters;

    const [SideMapComponent, onToggleSideMap] = useSidePanelMap();
    const [currentRowsPerPage, setCurrentRowsPerPage] = useState(10);
    const [currentNewSortField, setCurrentNewSortField] = useState("deviceId");
    const [currentNewSortOrder, setCurrentNewSortOrder] = useState("asc");

    const exportHandler = useHandleExportReport(report)

    const loadingCreateLandMark = useSelector(state => state.vehicleLandMarkRedux.loadingCreateLandMark)
    const createLandMarkResult = useSelector(state => state.vehicleLandMarkRedux.createLandMarkResult)

    const reportRef = useRef();
    const dispatch = useDispatch()

    useEffect(() => {
        if (report) {
            const newReport = JSON.parse(JSON.stringify(report));
            // to keep the reference to the units selected
            reportRef.current = newReport;
        }
    }, [JSON.stringify(report)]);

    useEffect(() => {
        if (!loadingCreateLandMark && createLandMarkResult) {
            dispatch(reportsMainGenerateReportUpdate(report, currentPage, currentRowsPerPage, currentNewSortField, currentNewSortOrder))
            dispatch(clearRedux("LANDMARK", {"createLandMarkResult": null}));
        }

    }, [loadingCreateLandMark, createLandMarkResult])

    const onChangeExpandable = (unit) => {
        if(!unit.noData){
            let events = {
                data: [],
                filters: {
                    filterType: getCategoryFilterType(filterEntity),
                    filterArray: unit,
                    page: 1,
                    rowsPerPage: 10,
                    sortField: 'eventDate',
                    otherFilters
                }
            }
            dispatch(reportsMainGenerateEvents(report, events))
        }
    }

    const existLabel = (label) => {
         if (label == null || label === "" || label == undefined) {
             return '--';
         }
        return label
    }

    const colorLabelEventName = (eventName) => {
        let color = 'black'
        switch (eventName.toLowerCase()) {
            case "ignition on":
                 color = 'blue';
                 break
            case "travel start":
            case "drive":
            case "update":
            case "main power on":
            case "geofence in":
            case "turn":
            case "locate":
            case "ping":
                 color = 'green';
                 break
            case "stop":
            case "travel stop":
            case "ignition off":
            case "geofence out":
            case "main power off":
                color = 'red';
                break
            case "idle":
            case "idling":
            case "idling end":
                 color = 'yellow';
                 break
            case "input 2 on":
            case "rapid acceleration":
            case "hard brake":
            case "sudden stop":
            case "hard turn":
                color = 'purple';
                break
            default:
                color = 'black';
                break
        }

        return color
    }

    let parametersSummary = useTableReport(
        {
            data,
            report,
            messages,
            hideHeader: false
        }
    );

    const renderExpandableRow = (row) => {

        let parametersSummaryTable = {
            ...parametersSummary,
            data: summary?.items || [],
            totalItems: summary?.total || 0,
            hideHeader: false,
            serverSideTable: true,
            onChangedPage: (page, rowsPerPage, sortField, sortOrder) => {
              let events = {
                data: [],
                filters: { filterType: getCategoryFilterType(filterEntity), filterArray: row, page, rowsPerPage, sortField, sortOrder, otherFilters }
              }
              dispatch(reportsMainGenerateEvents(report, events))
            },
            onChangeSelector: null,
            itemsSelector: null,
            generateExport: false,
            hideSelectorUnitsDriver: true,
            groups:report.filters.units || [],
            hideNumberOfRows:true,
            centerPagination: true,
          };

        return (
            <div>
                <Table
                   {...parametersSummaryTable}
                   loading={loadingSummary}
                   noData={row.noData}
                >
                    <Column label={messages["reportsMainRT_TimeDate"]} field="dateTime" noSorting>
                        {(element) => {
                            const formatDate = formatDatetime(element.dateTime, 'MM/DD/YYYY h:mm A', timeZone)
                            return (
                                <div>
                                    <span>{formatDate}</span>
                                </div>
                            )
                        }}
                    </Column>
                    <Column label={messages['reportsMainRT_EventName']} field="eventName" noSorting>
                        {(element) => {
                            const formatLabel = existLabel(element.eventName)
                            return (
                                <div>
                                    <span style={{color: colorLabelEventName(element.eventName)}}>{formatLabel}</span>
                                </div>
                            )
                        }}
                    </Column>
                    <Column label={messages["reportsMainRT_absActive"]} field="abs" noSorting>
                        {(element) => {
                              const formatLabel = existLabel(element.abs)
                            return (
                                <div>
                                    <span>{formatLabel}</span>
                                </div>
                            )
                        }}
                    </Column>
                    <Column label={messages["reportsMainRT_absIndicator"]} field="absActiveLamp" noSorting>
                        {(element) => {
                            const formatLabel = existLabel(element.absActiveLamp)
                            return (
                                <div>
                                    <span>{formatLabel}</span>
                                </div>
                            )
                        }}
                    </Column>
                    <Column label={messages["reportsMainRT_airBagIndicator"]} field="airBagIndicator" noSorting>
                        {(element) => {
                            const formatLabel = existLabel(element.airBagIndicator)
                            return (
                                <div>
                                    <span>{formatLabel}</span>
                                </div>
                            )
                        }}
                    </Column>
                    <Column label={messages["reportsMainRT_brakeIndicator"]} field="brakeIndicator" noSorting>
                        {(element) => {
                            const formatLabel = existLabel(element.brakeIndicator)
                            return (
                                <div>
                                    <span>{formatLabel}</span>
                                </div>
                            )
                        }}
                    </Column>
                    <Column label={messages["reportsMainRT_brakeSwichStatus"]} field="brake" noSorting>
                        {(element) => {
                            const formatLabel = existLabel(element.brake)
                            return (
                                <div>
                                    <span>{formatLabel}</span>
                                </div>
                            )
                        }}
                    </Column>
                    <Column label={messages["reportsMainRT_coolantHotLight"]} field="coolantLight" noSorting>
                        {(element) => {
                            const formatLabel = existLabel(element.coolantLight)
                            return (
                                <div>
                                    <span>{formatLabel}</span>
                                </div>
                            )
                        }}
                    </Column>
                    <Column label={messages["reportsMainRT_cruiseControl"]} field="cruiseControl" noSorting>
                        {(element) => {
                            const formatLabel = existLabel(element.cruiseControl)
                            return (
                                <div>
                                    <span>{formatLabel}</span>
                                </div>
                            )
                        }}
                    </Column>
                    <Column label={messages["reportsMainRT_ignitionStatus"]} field="ignitionStatus" noSorting>
                        {(element) => {
                            const formatLabel = existLabel(element.ignitionStatus)
                            return (
                                <div>
                                    <span>{formatLabel}</span>
                                </div>
                            )
                        }}
                    </Column>
                    <Column label={messages["reportsMainRT_milStatus"]} field="milStatus" noSorting>
                        {(element) => {
                            const formatLabel = existLabel(element.milStatus)
                            return (
                                <div>
                                    <span>{formatLabel}</span>
                                </div>
                            )
                        }}
                    </Column>
                    <Column label={messages["reportsMainRT_oilPressure"]} field="oilPressure" noSorting>
                        {(element) => {
                            const formatLabel = existLabel(element.oilPressure)
                            return (
                                <div>
                                    <span>{formatLabel}</span>
                                </div>
                            )
                        }}
                    </Column>
                    <Column label={messages["reportsMainRT_pto"]} field="pto" noSorting>
                        {(element) => {
                            const formatLabel = existLabel(element.pto)
                            return (
                                <div>
                                    <span>{formatLabel}</span>
                                </div>
                            )
                        }}
                    </Column>
                    <Column label={messages["reportsMainRT_seatBelt"]} field="seatBelt" noSorting>
                        {(element) => {
                            const formatLabel = existLabel(element.seatBelt)
                            return (
                                <div>
                                    <span>{formatLabel}</span>
                                </div>
                            )
                        }}
                    </Column>
                    <Column label={messages["reportsMainRT_dtc"]} field="dtc" noSorting>
                        {(element) => {
                            const formatLabel = existLabel(element.dtc)
                            return (
                                <div>
                                    <span>{formatLabel}</span>
                                </div>
                            )
                        }}
                    </Column>
                </Table>
            </div>
        )
    }

    let parametersTable = useTableReport({
        data: data.items,
        report,
        messages,
        hideHeader: true,
        renderExpandableRow,
        onChangeExpandable,
        propertyToShowExpandable: 'id',
        classNameColumns: 'start-stop-idle-main-table'
    });

    return (
        <Fragment>
            <Table
                {...parametersTable}
                {...exportHandler}
            >
                <Column label="Day" field="label" noSorting>
                    {(element) => {
                        return (
                            <div>
                                <span><strong>{getNameVehicle(filterEntity, messages)}:</strong> {element.idLabel} </span>
                            </div>
                        );
                    }}
                </Column>
                <Column label={messages['generatedReport_totalIdleTime']} field="label" noSorting>
                    {(element) => {
                        const localTimeStart = moment.utc(startRange).local().format();
                        const localTimeEnd = moment.utc(endRange).local().format();
                        return (
                            <div>
                                <span>
                                  <span>
                                    <strong>{messages['generatedReport_range']}:</strong> {` ${formatDatetime(localTimeStart, "MMMM D, YYYY h:mm A", timeZone)} - ${formatDatetime(localTimeEnd, "MMMM D, YYYY h:mm A", timeZone)}`}
                                  </span>
                                </span>
                            </div>
                        );
                    }}
                </Column>
            </Table>
            <SideMapComponent hiddenButton hiddenSearchMap/>
        </Fragment>
    );
}


export default DiagnosticIndicatorsReport;
